<template>
	<div class="communityView mt-5">
		<div
			:style="{ paddingTop: communityView.sponsored_by ? '22px' : '12px' }"
			class="communityView__info"
		>
			<SponsorBadge
				v-if="communityView.sponsored_by"
				:text="sponsoredText"
				icon="star"
				top="0"
				right="0"
			/>
			<span v-if="communityView.category_name" class="communityView__info__name px-3">{{
				communityView.category_name
			}}</span>
			<div class="communityView__info__buttons">
				<button
					:style="buttonStyle"
					@click="$emit('addToBookmark')"
					class="communityView__info__buttons__button"
				>
					{{ bookmarked ? 'Joined' : 'Join' }}
				</button>
			</div>
		</div>
		<div
			v-if="communityView && communityView.category_description"
			class="communityView__info py-3 px-3"
		>
			<span class="communityView__info__title">About</span>
			<ExpandableHtml
				:content="communityView.category_description"
				:expandText="'Show More'"
				:collapseText="'Show Less'"
			/>
		</div>
		<div class="communityView__info py-3 px-3">
			<span class="communityView__info__title pb-1">Details</span>
			<div class="communityView__info__details-container">
				<div class="communityView__info__details-container__details">
					<span class="communityView__info__details-container__details__title">
						Participants
					</span>
					<span class="communityView__info__details-container__details__count">
						{{ userCounter }}
					</span>
				</div>
				<div class="communityView__info__details-container__details">
					<span class="communityView__info__details-container__details__title">
						Discussions</span
					>
					<span class="communityView__info__details-container__details__count">
						{{ communityView.forum_count }}</span
					>
				</div>
				<div class="communityView__info__details-container__details">
					<span class="communityView__info__details-container__details__title">
						Last Activity
					</span>
					<span class="communityView__info__details-container__details__count">
						{{ calcDateAgo(communityView.date_last_active) }}</span
					>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ExpandableHtml from '@/components/ExpandableHtml.vue'
import moment from 'moment/moment'
import SponsorBadge from '@/components/SponsorBadge.vue'
import Dwh from '@/mixins/Dwh'

export default {
	name: 'CommunityView',
	components: { SponsorBadge, ExpandableHtml },
	mixins: [Dwh],
	props: {
		communityView: {
			type: Object,
			default: () => ({}),
		},
		userCounter: {
			type: Number,
			default: 0,
		},
		bookmarked: {
			type: Number,
			default: null,
		},
	},
	computed: {
		buttonStyle() {
			return {
				color: this.bookmarked ? 'var(--secondary_color)' : '#ffffff',
				border: this.bookmarked ? '1px solid var(--secondary_color)' : 'none',
				backgroundColor: this.bookmarked ? '' : 'var(--primary_color)',
			}
		},
		sponsoredText() {
			return `Sponsored by ${this.communityView.sponsored_by}`
		},
	},
	mounted() {
		this.sendTrigger({
			category: 'Community View',
			action: 'view_community_about',
			module: 'Forums / Communities',
			title: this.$route.query.name,
			id1: this.$route.params.id,
		})
	},
	methods: {
		calcDateAgo(date) {
			const now = moment()
			const target = moment(date * 1000)

			const diffMinutes = now.diff(target, 'minutes')
			const diffHours = now.diff(target, 'hours')
			const diffDays = now.diff(target, 'days')
			const diffMonths = now.diff(target, 'months')
			const diffYears = now.diff(target, 'years')
			if (diffYears >= 2) {
				return target.format('MMMM YYYY')
			}

			if (diffMinutes < 60) {
				return `${diffMinutes}min ago`
			}

			if (diffHours < 24) {
				return `${diffHours}h ago`
			}

			if (diffDays < 30) {
				return `${diffDays}d ago`
			}

			if (diffMonths < 12) {
				return `${diffMonths}mo ago`
			}

			return `${diffYears}y ago`
		},
	},
}
</script>
<style lang="scss">
.communityView {
	display: flex;
	flex-direction: column;
	gap: 8px;
	font-family: 'Inter', sans-serif;
	&__info {
		display: flex;
		flex-direction: column;
		position: relative;
		gap: 8px;
		background-color: #ffffff;
		border-radius: 8px;
		border: 1px solid #e2e2e2;
		&__name {
			font-weight: 700;
			font-size: 20px;
			line-height: 22px;
			letter-spacing: 0;
			color: var(--primary_color);
		}
		&__buttons {
			padding: 12px;
			border-top: 1px solid #e2e2e2;
			&__button {
				width: 100%;
				height: 46px;
				border-radius: 8px;
				border: 1px solid var(--secondary_color);
				font-weight: 700;
				font-size: 18px;
				line-height: 100%;
				letter-spacing: 0;
				text-align: center;
				color: var(--secondary_color);
			}
		}
		&__title {
			font-weight: 700;
			font-size: 18px;
			line-height: 100%;
			letter-spacing: 0;
			color: #4a4a4a;
		}
		&__details-container {
			display: flex;
			flex-direction: column;
			gap: 8px;
			&__details {
				display: flex;
				flex-direction: column;
				gap: 8px;
				background-color: #f3f3f6;
				padding: 12px;
				border-radius: 8px;
				&__title {
					font-weight: 700;
					font-size: 16px;
					line-height: 100%;
					letter-spacing: 0;
					color: #4a4a4a;
				}
				&__count {
					font-weight: 400;
					font-size: 16px;
					line-height: 140%;
					letter-spacing: 0;
					color: #4a4a4a;
				}
			}
		}
	}
}
</style>
